export default {
  login: {
    phonePlaceholder: '手机号',
    captchaPlaceholder: '验证码',
    getCaptcha: '获取验证码',
    captchaCountdown: '{seconds}秒',
    captchaSent: '验证码已发送',
    tabLogin: '登录',
    tabRegister: '注册',
    registerAndLogin: '注册并登录',
    fsRegisterLink: '新用户请前往 FS 注册',
    agreementPrefix: '我已阅读并同意',
    agreementAnd: '和',
    agreementIpePlatform: '《思政教学辅助系统用户协议》',
    agreementFsPlatform: '《卅三课件平台协议》',
    agreementPrivacy: '《隐私政策》',
    selectSubject: '选择学科',
    subjectModalTitle: '欢迎使用卅三数智学习平台',
    subjectModalSubtitle: '请选择学科',
    slogan1: '知识无界 学习无限',
    slogan2: '卅三领航 共享智慧成长',
    slogan: '知识无界 学习无限 卅三领航 共享智慧成长',
    platformName: '卅三数智学习平台',
    orgName: '卅三智慧教育科技',
    reportContact:
      '违法和不良信息举报电话：⁠15910773861 ｜ 举报邮箱：bot@bj33smarter.com',
    reportNotice:
      '如您发现相关资料侵犯您的合法权益，请联系北京卅三智慧教育科技有限公司，我们核实后将及时进行处理。',
    companyInfo: '技术支持与运营： 北京卅三智慧教育科技有限公司',
    error: {
      userNotExist: '此手机号暂未注册，请注册后登录',
      phoneInvalid: '手机号格式错误，请确认后重新输入',
      phoneExists: '此手机号已注册，请直接登录',
      userDisabled: '账号已停用，请联系管理员',
      registerNotOpen: '暂未开放注册，请联系管理员',
      registerRateLimited: '操作过于频繁，请稍后重试',
      loginRateLimited: '登录尝试过于频繁，请稍后重试',
      platformNotBound: '用户未绑定该平台，请联系管理员',
      captchaError: '验证码错误或已失效，请重新获取',
      smsCaptchaSent: '验证码已发送，请稍后再试',
      smsUnavailable: '验证码服务暂不可用，请稍后重试',
      smsDailyLimit: '已超过短信验证码接收最大次数',
      captchaSendFailed: '验证码发送失败，请稍后重试',
      operationFailed: '操作失败，请稍后重试',
      phoneRequired: '请输入手机号！',
      captchaRequired: '请输入验证码！',
      agreementRequired: '请同意协议！',
      subjectRequired: '请选择学科',
      subjectMissing: '没有选择学科，请重新登录',
    },
  },
  mainLayout: {
    platformName: '卅三数智学习平台',
    title: '卅三数智学习平台（{subject}）',
    historySession: {
      history: '历史记录',
      favorites: '收藏夹',
      empty: '暂无内容',
      expiredWarning: '该对话内容已超出 180 天保留限制，无法查看或恢复;',
      unknownTypeError: '无法打开此对话：未知的对话类型 "{type}"',
      favorite: '收藏',
      unfavorite: '取消收藏',
      favoriteSuccess: '收藏成功',
      favoriteFailed: '收藏失败',
      unfavoriteSuccess: '取消收藏成功',
      unfavoriteFailed: '取消收藏失败',
      rename: '重命名',
      renameSuccess: '重命名成功',
      renameFailed: '重命名失败',
      delete: '删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      hasPptWarning: '该对话下有已经生成的PPT，无法删除',
      deleteConfirmTitle: '确定删除此对话？',
      deleteConfirmContent:
        '删除后，【历史对话】和【收藏夹】里的聊天记录一并被删除且不可恢复。',
      renameModalTitle: '编辑对话名称',
      namePlaceholder: '请输入对话名称',
    },
    settings: '设置',
    logout: '退出登录',
    newChat: '新对话',
    comingSoon: '敬请期待！',
    myTeachingResources: '我的教学资源',
    myCoursewarePackage: '我的课件包',
    myCourseware: '我的课件',
    resourceSquare: '资源广场',
    agentMaterial: '智能素材库',
    learningSpace: '学习空间',
    smartTools: '智能工具',
    smartCourseware: '数智化课件',
    myStudents: '我的学生',
    classroomCourseware: '课堂课件',
    smartCoursewarePackage: '数智化课件包',
    smartCoursewarePackageComponent: '数智化课件包组件',
  },
  settings: {
    back: '返回',
    navPersonal: '个人信息',
    navSchool: '学校信息',
    navAccount: '账号管理',
    navOrders: '我的订单',
    navAbout: '关于我们',
    accountTitle: '账户信息',
    accountId: '账号ID',
    phone: '手机号码',
    schoolId: '学校ID',
    schoolName: '学校名称',
    area: '区域',
    personalTitle: '个人信息',
    name: '姓名',
    nameRule: '请输入姓名，支持中文、字母、数字',
    gender: '性别',
    genderMale: '男',
    genderFemale: '女',
    pleaseSelect: '请选择',
    areaTitle: '所在区域',
    areaPlaceholder: '省-市-区/县',
    eduLevels: '偏好学段设置',
    eduLevelsRequired: '请选择偏好学段设置',
    eduLevelsPlaceholder: '设置学段',
    updateProfile: '更新个人信息',
    updateSuccess: '更新成功',
    ordersTitle: '我的订单',
    packageName: '套餐名称',
    orderNo: '订单号',
    paidAt: '支付时间',
    amount: '金额',
    status: '状态',
    paid: '已支付',
    action: '操作',
    billDetail: '账单详情',
    billTitle: '账单详情',
    channel: '支付渠道',
    paymentMethod: '支付方式',
    acquirer: '收单机构',
    channelTradeNo: '第三方交易号',
    paymentNo: '我方支付单号',
    channelWechat: '微信支付',
    channelAlipay: '支付宝',
    billLoadFailed: '获取账单失败，请稍后重试',
    privacyPolicy: '隐私政策',
    viewNow: '立即查看>',
  },
  cloudDisk: {
    overview: '概览',
    smartCourseware: '数智化课件',
    projectFolder: '项目文件夹',
    unclassified: '未分类',
    used: '已使用',
    capacityHint:
      '（长期有效，包含所有学科AI生成的数智化课件+项目文件夹+零散对话产物）',
    name: '名称',
    type: '类型',
    updatedAt: '更新时间',
    size: '大小',
    action: '操作',
    ok: '确定',
    cancel: '取消',
    delete: '删除',
    preview: '预览',
    edit: '修改',
    download: '下载',
    deleteSuccess: '删除成功',
    noFiles: '暂无文件',
    noFilesOfType: '暂无该类型文件',
    noResults: '未找到相关文件',
    allTypes: '全部类型',
    inputName: '输入名称',
    searchFilePlaceholder: '请输入文件名称',
    searchFolderOrFilePlaceholder: '请输入文件夹/文件名称',
    searchCoursewarePlaceholder: '请输入课件名称',
    typeDocument: '文档',
    typeSpreadsheet: '表格',
    typePpt: 'PPT',
    typeHtml: 'HTML',
    typeMarkdown: 'Markdown',
    typeImage: '图片',
    typeAudio: '音频',
    typeOther: '其他',
    typePdf: 'PDF',
    typeVideo: '视频',
    typeCourseware: '课件',
    editInfoMissing: '文件编辑信息缺失',
    editNotSupported: '该格式暂不支持在线编辑',
    confirmDeleteFile: '确定删除该文件吗？',
    deleteFileWarning: '删除后，文件不可恢复。',
    deleteFileChatHint:
      '点击该对话产物中的【存储到云盘】，可重新添加文件至云盘。',
    fileMissingDownload: '文件不存在，无法下载',
    fileMissing: '文件不存在',
    previewNotSupported: '该格式暂不支持预览',
    storageFullTitle: '云盘空间已满',
    storageFullContent: '仅支持查看，请先清理',
    gotIt: '知道了',
    downloadNotSupported: '该格式暂不支持下载',
    coursewareName: '课件名称',
    detailInfo: '详细信息',
    updatedDate: '更新日期',
    confirmDeleteCourseware: '确定删除该课件吗？',
    deleteCoursewareWarning:
      '删除后，数智化课件列表中该课件数据一并被删除，请谨慎操作。',
    currentVersion: '当前版本',
    unnamed: '未命名',
    scaffold: '脚手架',
    dateFormat: 'YYYY年MM月DD日 HH:mm',
    shortDateFormat: 'M月D日 HH:mm',
    recentStorage: '最近存储',
    viewAll: '全部 →',
    noProjectFolders: '暂无项目文件夹',
    loading: '加载中…',
    noStorageRecords: '暂无存储记录',
    unitFile: '份',
    unitItem: '个',
    statTotal: '数智化课件 + 对话文件',
    statCourseware: '数智化课件',
    statProjectFolder: '项目文件夹（{count}个文件）',
    statUnclassified: '未分类',
    confirmDeleteFolder: '确定删除该项目文件夹吗？',
    deleteFolderWarning:
      '删除后，该项目文件夹中的文件内容一并被删除，请谨慎操作。',
  },
  ic: {
    creationLimit: '您储存的课件包已经超出上限请删除旧课件包再进行操作',
    communityLimit: '您储存的课件已经超出上限请删除旧课件再进行操作',
    onlineCreate: '在线创作',
    communityTitle: '资源课件包',
    communityGuide: '点击课件卡选项中的【申请上传】可提交公开课件包哦',
    communityEmpty: '暂无公开课件',
    selectTextbook: '请选择教材',
    gradeLabel: '年级：',
    editionLabel: '版本：',
    textbookLabel: '教材：',
    editionTextbook: '版本教材',
    searchPlaceholder: '请输入课件包名称搜索',
    myCourseware: '我的课件包',
  },
  fsPlayer: {
    backToEdit: '返回制作',
  },
  fsCourseware: {
    ok: '确定',
    cancel: '取消',
    delete: '删除',
    save: '保存',
    preview: '预览',
    edit: '编辑',
    upload: '上传',
    create: '创建',
    choose: '选用',
    restore: '恢复',
    renameName: '修改名称',
    comingSoon: '敬请期待',
    defaultModuleName: '新模块 {order}',
    defaultTagName: '新标签 {order}',
    defaultLectureName: '文件',
    defaultTagFolderName: '标签文件夹',
    defaultScaffoldName: '脚手架',
    defaultLectureDisplayName: '文件{count}',
    kindName: '名称',
    kindCourseware: '课件',
    kindModule: '模块',
    kindTag: '标签',
    kindButton: '按钮',
    inputNameTitle: '请输入{kind}名称',
    inputName: '请输入名称',
    editNameTitle: '编辑{kind}名称',
    maxLengthExceeded: '最多输入{count}个字',
    addModule: '添加模块',
    addModuleAriaLabel: '新增模块',
    addTag: '添加标签',
    addButton: '添加按钮',
    deleteModuleTitle: '模块删除',
    confirmDeleteModule: '你确定要删除该模块吗？',
    deleteTagTitle: '标签删除',
    confirmDeleteTag: '你确定要删除该标签吗？',
    deleteLectureTitle: '文件删除',
    confirmDeleteLecture: '你确定要删除该文件吗？',
    renameButtonName: '编辑按钮名称',
    deleteButtonName: '删除操作按钮',
    replaceDisplayFile: '更换展示文件',
    removeDisplayFile: '移除展示文件',
    moreActions: '更多操作',
    confirmRemoveDisplayFile: '确定移除展示文件吗？',
    removeDisplayFileWarning: '移除后，文件将不可恢复。',
    removeSuccess: '移除成功',
    removeFailed: '移除失败，请重试',
    confirmDeleteCourseware: '确认删除课件吗？',
    deleteCoursewareWarning: '删除后不可恢复，请谨慎操作。',
    deleteSuccess: '删除成功',
    aiGenerate: '智能生产课件',
    aiAnalysis: 'AI智能分析',
    versionManager: '版本管理',
    saveAsVersion: '保存为版本',
    versionName: '版本名称',
    versionNamePlaceholder: '请输入版本名称',
    saveVersionSuccess: '保存成功！',
    saveVersionFailed: '保存版本失败，请重试',
    restoreSuccess: '「{name}」内容恢复成功！',
    restoreFailed: '恢复版本失败，请重试',
    restoreHint: '仅恢复手动保存的最近一次的版本',
    fileModalCreateTitle: '创建{name}内容',
    fileModalUploadTitle: '上传{name}内容',
    fileModalCreateFooter: '创建文件',
    fileModalUploadFooter: '上传文件',
    fileNameLabel: '文件名称',
    fileNamePlaceholder: '请输入文件名称',
    pathLabel: '路径',
    scaffoldLabel: '脚手架',
    uploadPlaceholderHint: '仅支持PPT/PDF/HTML/MP4/WEBM，200MB以内',
    h5LinkLabel: 'H5链接',
    urlPlaceholder: '请输入网址',
    h5UrlInvalid: '请输入合规网站，例：http:// 或  https://开头',
    emptyFileContent: '暂无文件内容',
    dropToUpload: '松开鼠标即可上传文件',
    dragUploadHint: '拖拽本地文件上传或使用下方按钮上传、创建、选用',
    uploading: '正在上传，请稍候...',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败，请重试',
    createFailed: '创建失败，请重试',
    unsupportedFileType: '不支持的文件类型',
    unsupportedFileFormat: '不支持得文件格式',
    fileInfoInvalidReupload: '文件信息异常，请重新上传',
    fileInfoInvalid: '文件信息异常，请重试',
    coursewareInfoInvalid: '课件信息异常，请重试',
    resourceCreateFailed: '资源创建失败，请重试',
    unsupportedUploadType: '仅支持PPT、PDF、HTML、MP4、WEBM文件',
    maxSizeExceeded: '上传文件不能超过{size}M',
    uploadUrlMissing: '上传地址不能为空',
    uploadTokenFailed: '获取上传 token 失败',
    confirmRemoveScaffold: '你确定移除此课件吗？',
    removeScaffoldWarning: '移除后，课件将不可恢复',
    scaffoldPanelTitle: '{name}-脚手架',
    structureSyncFailed: '同步课件结构失败，请稍后重试',
    previewParamsMissing: '缺少预览参数，请返回后重试。',
    previewOnlyMedia: '当前仅支持音视频资源预览。',
    previewUrlFailed: '获取预览地址失败，请稍后再试。',
    goBack: '返回上一页',
  },
  fsAgentMaterial: {
    tabCoursewareMaterial: '数智化课件',
    tabAgentGeneratedMaterial: 'AI智能生成素材',
    searchPlaceholder: '输入文件名称搜索内容',
    fileName: '文件名称',
    detailInfo: '详细信息',
    status: '状态',
    action: '操作',
    preview: '预览',
    edit: '修改',
    download: '下载',
    delete: '删除',
    inputName: '输入名称',
    stored: '已存储',
    editInfoMissing: '文件编辑信息缺失',
    editNotSupported: '该格式暂不支持在线编辑',
    previewUrlFailed: '获取预览地址失败',
    confirmDeleteFile: '确认要删除该文件吗？',
    deleteFileWarning: '注意：此操作无法撤销且文件不可再下载',
    noResources: '暂无资源',
    emptyDescription: '目前还没有文件快去生成吧',
    unnamed: '未命名',
    scaffold: '脚手架',
    coursewareName: '课件名称',
    updatedDate: '更新日期',
    type: {
      teachingPlanUnit: '大单元教学设计',
      teachingPlanLesson: '课时教学设计',
      verbatimScript: '逐字稿',
      homeworkPreview: '课前预习',
      homeworkReview: '课后复习',
      examQuiz: '随堂测试',
      examUnit: '单元测试',
      examFinal: '学期测试',
      pblStudyPlan: 'PBL项目设计',
    },
  },
  learningSpace: {
    documentMaterial: '文件资料',
    coursewareMaterial: '示例课件',
    searchPlaceholder: '输入文件名称搜索内容',
    dateFormat: 'YYYY年MM月DD日',
    noResources: '暂无资源',
    emptyDescription: '敬请期待其他老师的分享',
    coursewareInfo: '课件信息',
    fileInfo: '文件信息',
    updatedAt: '更新时间',
    publisher: '发布人',
  },
  fsIntelligenceCourseware: {
    all: '全部',
    ok: '确定',
    cancel: '取消',
    onlineCreate: '在线创作',
    searchPlaceholder: '请输入课件名称搜索',
    courseware: '课件',
    teachingTypeUnit: '大单元教学',
    teachingTypeSection: '课堂教学',
    teachingTypeUnclassified: '未分类',
    createTitle: '制作数智化课件',
    structureBlank: '空白创建',
    structureSssdUnit: '卅三大单元结构模板',
    structureSssdCourse: '卅三课程结构模板',
    createSubmit: '创建课件',
    createSuccess: '创建成功',
    nameDuplicated: '课件名称重复',
    unitStorageNotice:
      '所有课件仅支持在【单元】范围内存储，如您的课件不属于当前单元，请关闭此页面在左侧切换【单元】后继续操作。',
    selectSubjectGrade: '选择学科及年级',
    selectSubjectGradeRequired: '请选择学科及年级',
    subjectGradePlaceholder: '学科/年级',
    coursewareUnitLabel: '课件所属单元',
    coursewareUnitRequired: '请选择课件所属单元',
    structureLabel: '选择结构',
    structureRequired: '请选择结构',
    coverLabel: '课程封面',
    coverRequired: '请设置课程封面',
    nameLabel: '课件名称',
    namePlaceholder: '请输入课件名称',
    uploadImage: '上传图片',
    changeUploadImage: '更换上传图片',
    uploadImageHint: '仅支持上传JPG/PNG/JPEG，大小不超过2M',
    uploading: '上传中',
    uploadingDots: '上传中...',
    materialCover: '素材封面',
    changeMaterialCover: '更换素材封面',
    selectTextbook: '请选择教材',
    stageLabel: '学段：',
    subjectLabel: '学科：',
    gradeLabel: '年级：',
    editionLabel: '版本：',
    textbookLabel: '册次：',
    editionTextbook: '版本教材',
    unitResourceTitle: '本单元资源课件',
    uploadGuide: '点击课件卡选项中的【申请上传】可提交公开课件哦',
    publicTypeLabel: '公开类型：',
    coursewareTypeLabel: '课件类型：',
    noPublicCourseware: '暂无公开课件',
    scopeSchool: '校级公开',
    scopePlatform: '平台公开',
    myCoursewareNav: '【我的课件】',
    obtain: '获取',
    moveTitle: '移动至当前单元',
    moveSuccess: '移动成功',
    selectSectionPlaceholder: '请选择当前单元下的课',
    unitTab: '大单元',
    updatedDateLabel: '更新日期：',
    creatorLabel: '制作人：',
    schoolLabel: '所属学校：',
    createdByMe: '我制作的',
    officialCourseware: '官方课件',
    detail: '详情',
    uploadBlockPrefix: '请点击',
    uploadBlockMoveTo: '【移动至】',
    uploadBlockMiddle: '，将课件分类后，才能',
    uploadBlockApplyUpload: '【申请上传】',
    uploadBlockSuffix: '至本单元资源课件',
    loadingMore: '加载中...',
    noMatchCourseware: '未找到匹配课件',
  },
  contentTree: {
    ok: '确定',
    cancel: '取消',
    delete: '删除',
    save: '保存',
    templateName: '模板名称',
    unknownError: '未知错误',
    missingCoursewareId: '缺少课件ID',
    getHermesTreeFailed: '获取 Hermes 树数据失败',
    nameLabel: '名称:{name}',
    nodeType: {
      root: '根节点',
      rootShort: '根',
      module: '模块',
      reference: '引用',
      slot: '槽位',
      tag: '标签',
      transition: '过渡',
    },
    deleteNodeTitle: '确认删除节点',
    deleteNodeConfirm: '确定要删除节点「{name}」吗？',
    deleteNodeChildrenWarning: '该节点包含子节点，删除后子节点也将一并删除',
    executeConfirmTitle: '保存并执行',
    executeConfirmContent:
      '系统将创建版本快照，并自动执行 AI 生成所有槽位节点的内容',
    executeConfirmOk: '确认执行',
    moduleSelectTitle: '选择生成模块',
    moduleSelectOk: '确认生成',
    moduleSelectAll: '全选',
    moduleSelectCount: '已选 {selected} / {total}',
    moduleSelectSlotCount: '{count} 个槽位',
    modals: {
      treeDescriptionTitle: '展开TREE描述',
      unsupportedFileFormat: '暂不支持该文件格式',
      fileTooLarge: '文件大小不能超过 {size}MB',
      maxFiles: '最多上传 {count} 个文件',
      duplicateFile: '列表中已存在同名文件，请勿重复添加',
      uploadSuccess: '{name} 上传成功',
      uploadFailed: '{name} 上传失败',
      seedRequired: '请先输入TREE描述',
      uploadingWait: '参考文件上传中，请稍候',
      subjectUnknown: '无法确定当前课件所属学科',
      originName: '原点名称',
      originDescription: '原点描述',
      originDescriptionPlaceholder: '输入原点描述...',
      seedLabel: 'TREE描述（种子文本）',
      seedPlaceholder: '输入课件内容描述，用于AI生成大纲结构...',
      referenceFiles: '参考文件（可选）',
      uploadHint: '点击或拖拽上传参考文件',
      uploadFormats:
        '支持 PDF、Word、TXT、MD 格式，20MB 以内，最多支持上传 5 个文件',
      reopenHint: '关闭后可点击左下角「AI建树」随时重新打开',
      generating: 'AI生成中...',
      generateStructure: 'AI生成结构',
      loading: '加载中...',
      generateFullStructure: '课件结构全量生成',
    },
    editorTab: {
      design: 'TREE设计',
      review: '内容审阅',
      export: '转化导出',
    },
    editor: {
      aiBuildTree: 'AI建树',
      addRoot: '+原点',
      addModule: '+模块',
      addTag: '+标签',
      addSlot: '+槽位',
      addTransition: '+过渡',
      addReference: '+参考',
      noTreeData: '暂无内容树数据',
      buildTreeFirst: '请先点击AI建树生成结构',
      createModuleFirst: '请先创建模块',
      versionSaved: '版本已保存',
      saveVersionFailed: '保存版本失败',
      generateOrAddNodesFirst: '请先生成或添加节点',
      mdExported: 'MD文档已导出',
      exportMd: '导出md文档',
      outlineGeneratingPercent: '内容大纲生成中 {percent}%',
      generateOutline: '生成内容大纲',
      saveVersion: '存版本',
      versionHistory: '历史版本',
      exportFileNamePrefix: '内容树',
      treeCreated: '内容树创建成功',
      createFailed: '创建失败',
      back: '返回',
      generateFirstHint: '请先点击「生成内容大纲」生成内容',
      generatingHint: '内容大纲正在生成中，请稍后',
      noTreeTitle: '尚未创建内容树',
      noTreeSubtitle: '点击下方按钮为该课件创建一棵内容树',
      createTree: '创建内容树',
    },
    panel: {
      title: '节点详情',
      selectNodeHint: '选择节点查看详情',
      nodeName: '节点名称',
      showName: '回填名称',
      showNamePlaceholder: '留空则使用节点名称',
      typeLabel: '类型',
      promptTemplate: '提示词模板',
      promptTemplatePlaceholder: '输入提示词模板...',
      nodeDescription: '节点描述',
      descriptionPlaceholder: '输入描述...',
      deleteNode: '删除节点',
      referenceFileList: '引用文件列表',
      uploadFormatsDetail:
        '支持 PDF、Word、TXT、MD 格式，单个最大 20MB，最多上传 5 个文件',
      saveFailedRetry: '保存失败 · 点击重试',
      editingStatus: '编辑中…',
      savingStatus: '保存中…',
      savedStatus: '✓ 已保存',
    },
    exportPage: {
      loadingData: '加载导出数据...',
      exportDone: 'HTML 导出完成，可下载导出结果或回填',
      exportTimeout: '导出超时',
      exportFailedDetail: '导出失败: {message}',
      importTimeout: '导入超时',
      importDone: '导入课件平台完成',
      importFailedDetail: '导入失败: {message}',
      submittingExport: '正在提交导出任务...',
      exportTaskStarted: '导出任务已启动',
      triggerExportFailed: '触发导出失败',
      exportFirstHtml: '请先导出选中槽位的 HTML',
      downloadStarted: '导出结果下载已开始',
      downloadExportFailed: '下载导出结果失败',
      submittingImport: '正在提交导入任务...',
      importTaskStarted: '导入任务已启动',
      triggerImportFailed: '触发导入失败',
      promptSaved: '提示词已保存',
      promptSaveFailed: '提示词保存失败',
      htmlLoadFailed: 'HTML 加载失败',
      previewHint: '点击已生成 HTML 槽位的小眼睛进行预览',
      htmlGenerating: 'HTML正在生成中...',
      importWaitExporting: '导出进行中，请等待完成后再回填',
      downloadWaitExporting: '导出进行中，请等待完成',
      generatingPercent: '生成中 {percent}%',
      generateHtml: '生成 HTML',
      promptPlaceholderSelected: '展示选中槽位的样式提示词，可编辑后保存...',
      promptPlaceholderEmpty: '请先在左侧选择要导出的槽位',
      promptPanelTitle: 'HTML 样式提示词',
      previewTitle: 'HTML 效果预览',
      enlargeHint: '请先勾选已生成 HTML 的槽位',
      enlarge: '放大',
      shrink: '缩小',
      downloading: '下载中...',
      exportHtml: '导出 HTML',
      importToPlatform: '回填至课件平台',
      importingPercent: '导入中 {percent}%',
      importing: '导入中...',
      selectAllSlots: '全选（{selected}/{total} 个槽位）',
      cancelPreview: '取消预览',
      previewSlotHtml: '预览该槽位 HTML',
      htmlGenerated: '已生成 HTML',
      generatingHtml: '正在生成 HTML',
      htmlNotGenerated: '未生成 HTML',
      noContentPlaceholder: '> 暂无生成内容',
      contentPreviewTitle: '内容预览',
      selectedCount: '已选 {count} 个槽位',
      previewFirstOnly: ' · 预览展示首个',
      selectNodeHint: '请在左侧选择要导出的节点',
    },
    review: {
      loadingData: '加载审阅数据...',
      generatingPercent: '生成中 {percent}%',
      outlineEvaluation: '大纲评测',
      evaluationDisabledTip: '大纲生成中，完成后可发起评测',
      nextStep: '下一步',
      generatingContent: '正在生成内容…',
      noTreeData: '暂无树数据',
      generatingRemaining: '正在生成剩余内容…',
      noContent: '暂无生成内容',
      nothingToCopy: '暂无内容可复制',
      copied: '已复制到剪贴板',
      copyFailed: '复制失败',
      copyMarkdown: '复制 Markdown',
      copyMd: '复制MD',
      regenerateDone: '重新生成完成',
      regenerateFailed: '重新生成失败',
      hermesSaveFailed: 'Hermes 保存失败: {message}',
      savedHermesLocalSyncFailed: '已保存至 Hermes，但本地同步失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      hermesUpdatedLocalPartialFailed: 'Hermes 已更新，本地同步部分失败',
      selectNodeHint: '请在左侧选择节点查看内容',
      viewPrompt: '查看输入提示词',
      prompt: '提示词',
      editContent: '编辑内容',
      edit: '编辑',
      regenerate: '重新生成',
      regenerateTitle: '重新生成大纲',
      regeneratePromptLabel: '请输入修改期望，将基于当前内容重新生成大纲：',
      regeneratePromptPlaceholder: '例如：增加更多互动元素、简化语言难度...',
      noPromptToCopy: '暂无提示词可复制',
      promptDrawerTitle: '{name} · 输入提示词',
      copyPrompt: '复制提示词',
      copy: '复制',
      noPrompt: '该节点暂无提示词',
    },
    store: {
      hermesTimeout: 'Hermes 任务超时（4小时）',
      outlineDone: '内容大纲生成完成',
      hermesGenerateFailed: 'Hermes 课件生成失败',
      reconnectFailed: '网络异常，多次重连失败，请重新提交',
      submittingGeneration: '正在提交生成任务...',
      noPermission: '该用户没有权限，请联系管理员',
      uploadFailedDetail: '上传失败: {detail}',
      taskIdMissing: '未获取到任务ID',
      generationSubmitted: '已提交内容生成任务',
      uploadHermesFailed: '上传 Hermes 失败',
      resumingGeneration: '正在恢复生成任务...',
      generationStopped: '已停止生成',
    },
    requests: {
      getTreeFailedHttp: '获取 Hermes 树失败: HTTP {status}',
      getTreeFailed: '获取 Hermes 树失败',
      updateOutlineFailedHttp: '更新大纲失败: HTTP {status}',
      regenerateFailedDetail: '重新生成大纲失败: {detail}',
      regenerateFailed: '重新生成大纲失败',
      triggerExportFailedDetail: '触发导出失败: {detail}',
      triggerExportFailed: '触发导出失败',
      downloadFailedHttp: '下载导出结果失败: HTTP {status}',
      defaultZipFileName: '课件导出_{taskId}',
      triggerImportFailedDetail: '触发导入失败: {detail}',
      triggerImportFailed: '触发导入失败',
      queryExportStatusFailedHttp: '查询导出状态失败: HTTP {status}',
      queryImportStatusFailedHttp: '查询导入状态失败: HTTP {status}',
      getHtmlFailedHttp: '获取 HTML 失败: HTTP {status}',
      getModelConfigFailedHttp: '获取模型配置失败: HTTP {status}',
      configureModelFirst: '请先在 Agent 平台配置模型',
    },
    canvas: {
      zoomIn: '放大',
      zoomOut: '缩小',
      fitView: '适应视图',
      autoLayout: '自动布局',
    },
    templatePicker: {
      nameRequired: '请输入名称',
      renamed: '已重命名',
      renameFailed: '重命名失败',
      deleted: '已删除',
      deleteFailed: '删除失败',
      subjectOrGradeUnknown: '无法确定当前课件所属学科或学段',
      systemTemplateName: '「{name}」系统学科模板',
      userTemplateName: '「{name}」模板',
      displayName: '{name}（{creator}）',
      creatorFallback: '其他老师',
      replaceConfirm: '将清空当前内容并替换为{name}，是否继续？',
      applySuccess: '全量生成完成',
      applyFailed: '全量生成失败，请重试',
      applyTemplate: '套用模板',
      systemTemplateLabel: '系统学科模板（默认）',
      currentSubject: '当前学科',
      presetStructure: '{name} 预置结构',
      noDefaultPrompt: '暂无默认提示词，请上传',
      mine: '我的',
      deleteConfirm: '删除该模板？',
      noUserTemplates: '该学科暂无用户模板，将使用系统默认结构',
      renameTitle: '重命名模板',
    },
    uploadPrompts: {
      uploadButton: '上传全量提示词',
      fileModalTitle: '提示词文件',
      uploadHint: '点击或拖拽上传提示词文件',
      formatsHint: '仅支持 MD 格式，{size}MB 以内，最多支持上传 {count} 个文件',
      previewModalTitle: '预览：上传全量提示词',
      updateSuccess: '已更新「{subject}」学科模板：{slots} 槽位，填充 {filled}',
      nodeStat: '节点',
      slotStat: '槽位',
      filledStat: '有提示词',
      renderKeptStat: '保留渲染提示词',
      layerErrors: '⚠ 4 层校验失败（{count} 处）：',
      warnings: '警告：',
      unknownFiles: '未识别文件：',
      slotRatio: '{filled}/{total} 槽位',
      emptyModule: '空',
      renderUploadButton: '上传全量样式提示词',
      renderFileModalTitle: '样式提示词文件',
      renderUploadHint: '点击或拖拽上传样式提示词文件',
      renderPreviewModalTitle: '预览：上传全量样式提示词',
      renderUpdateSuccess:
        '已更新「{subject}」样式提示词：填充 {filled}，置空 {cleared}',
      filledLabel: '填充',
      clearedLabel: '置空',
      noSlotsToFill:
        '⚠ 没有可填充的槽位（槽位名与现有模板均不匹配），请检查 .md 格式或先上传大纲提示词。',
      unmatchedSlots: '未匹配槽位：',
      filledClearedRatio: '填充 {filled} / 置空 {cleared}',
      notMdSkipped: '{name} 不是 .md 文件，已跳过',
      exceedsSizeSkipped: '{name} 超过 {size}MB，已跳过',
      duplicateSkipped: '{name} 已上传，请勿重复',
      uploadFirst: '请先上传至少一个文件',
      parseFailed: '解析失败，请检查 .md 格式',
      writeFailed: '写入失败，请重试',
      parsePreview: '解析预览',
      backToEdit: '返回修改',
      confirmOverwrite: '确认覆盖',
    },
    versions: {
      restoreSuccess: '版本已恢复',
      restoreFailed: '恢复失败，请重试',
      defaultTemplateName: '{version} 模板',
      nameRequired: '请输入模板名称',
      savedAsTemplate: '已存为模板',
      saveAsTemplateFailed: '存为模板失败，请重试',
      versionColumn: '版本号',
      createdAtColumn: '创建时间',
      actionColumn: '操作',
      restore: '恢复',
      savedAs: '已存',
      saveAsTemplate: '存为模板',
      emptyTitle: '暂无版本记录',
      emptyHint: '点击「存版本」可保存当前状态',
      remarkLabel: '备注（选填）',
      namePlaceholder: '给这个模板起个名字',
      remarkPlaceholder: '简单描述这个模板的特点',
      sourceLine: '来源：{tree} · {version}',
      currentCourseware: '当前课件',
    },
    intro: {
      welcomeTitle: '欢迎使用 TREE 内容树设计',
      welcomeSubtitle:
        '将一节课的结构，编织成一棵可生长、可生成、可导出的知识树。',
      coreValuesTitle: '核心价值',
      nodesSectionTitle: '六类节点，各司其职',
      stepsSectionTitle: '四步上手',
      startButton: '开始使用',
      origin: '原点',
      originDesc: '树的唯一根节点',
      reference: '参考',
      referenceDesc: '跨节点引用',
      moduleDesc: '主要章节',
      tagDesc: '知识点标签',
      slotDesc: '具体内容单元',
      transitionDesc: '环节衔接',
      structuredTitle: '结构化组织',
      structuredDesc:
        '原点·模块·标签·槽位·过渡·参考，六类节点让课件层次清晰、关系分明。',
      aiTitle: 'AI 智能生成',
      aiDesc: '输入课程描述，AI 自动生成完整大纲；或按学科一键载入预置结构。',
      convertTitle: '一键转化',
      convertDesc:
        '导出 Markdown 文档，或根据树结构内容自动生成可编辑的完整课件大纲。',
      step1Title: '建立原点',
      step1Desc: '点击「+原点」创建整棵树唯一的根节点。',
      step2Title: '逐层搭建',
      step2Desc:
        '选中节点后，用「+模块 / +标签 / +槽位…」按层级规则添加子节点。',
      step3Title: 'AI 生成结构',
      step3Desc: '展开 TREE 描述，填写课程需求，一键生成大纲。',
      step4Title: '导出与生成',
      step4Desc: '保存为 Markdown 文档，或生成课件内容大纲。',
    },
    unitPath: {
      label: '当前所在单元：{path}',
    },
  },
  components: {
    resourceList: {
      theadInfo: '课件信息',
      theadUpdatedAt: '更新时间',
      theadUsage: '获取量',
      theadStatus: '状态',
      theadOperation: '操作',
      mineBadge: '我制作的',
      dateFormat: 'YYYY年M月D日',
      nameLabel: '名称',
      introLabel: '介绍',
      nameRequired: '请输入名称',
      changeNameTitle: '名称修改',
      ok: '确定',
      changeSuccess: '修改成功',
      nameDuplicated: '名称重复',
      unitGuide: '单元导学',
      thirdRowGuide: '{module} | 五维导学',
      thirdRowTopic: '{module} | {teachingCase} 主题',
      useSuccess: '获取成功',
      deleteTitle: '文件删除',
      deleteReferencedWarning:
        '该文件已被用于发布的课件中，删除后可能影响后续更新',
      deleteConfirm: '你确定要删除该文件吗？',
      deleteSuccess: '删除成功',
      preview: '预览',
      use: '获取',
      edit: '编辑',
      permissionSetting: '权限设置',
      delete: '删除',
      moreActions: '更多操作',
      scopePersonal: '个人私有',
      scopeSchool: '学校公开',
      scopePlatform: '平台公开',
    },
    aiEvaluation: {
      scoreFormatted: '{score} 分',
      scoreMissing: '未出分',
      evaluating: '评测中...',
      needsReconcile: '状态待确认',
      needsReconcileTooltip: '评测提交状态待确认，请联系管理员核对，勿重复发起',
      reportButton: '评测报告',
      lastScore: '上次评测：{score}',
      checkPassed: '基础检查通过',
      checkFailed: '基础检查未通过',
      checkUnknown: '基础检查结果未知',
      itemsDetail: '展开逐项详情（共 {total} 项，{failed} 项未通过）',
      involvedFiles: '涉及文件：{files}',
      fileListSeparator: '、',
      suggestionLabel: '建议：{suggestion}',
      reportTitle: 'AI 智能分析结果',
      latestOnlyHint: '（仅显示最近一次的评测报告）',
      noReport: '暂无评测报告',
      reconcileAlert:
        '本次评测状态待确认，请勿重复发起；以下为上一次的评测结果',
      evaluatingAlert: '本次评测仍在进行中，以下为上一次的评测结果',
      coursewareNameLabel: '课件名称',
      scoreLabel: '评分：{score}',
      fullScore: '总分：100',
      verdictPass: '通过',
      verdictFail: '未通过',
      fullReportAriaLabel: '查看完整评测报告（将在新标签页打开）',
      viewFullReport: '点击查看完整评测报告',
      failedReason: '失败原因',
      summaryInfo: '摘要信息',
      executionFailed: '评测任务执行失败',
      noSummary: '本次未生成摘要',
      completedTitle: '评测完成',
      completedDescription: '本次评测已完成，可查看评测报告',
      viewResult: '查看结果',
      failedTitle: '评测失败',
      failedFallback: '评测任务执行失败，可重新发起',
      reconcileTitle: '评测状态待确认',
      reconcileDescription:
        '评测提交状态无法确认，请联系管理员核对，勿重复发起',
      reusedTitle: '该课件已有评测在进行中',
      submittedTitle: '评测任务已提交',
      reusedDescription: '本次未重复发起，可稍后在评测报告中查看状态',
      submittedDescription: '评测在后台进行，可稍后在评测报告中查看结果',
      gotIt: '知道了',
      submitFailed: '评测任务提交失败',
    },
    coursewareInfinite: {
      lastMonth: '近一个月',
      lastThreeMonths: '近三个月',
      older: '近半年及以上',
      ownerCreated: '修改',
      ownerUsed: '获取',
      ownerCollaborated: '协作',
      usedTimeLabel: '获取时间：{date}',
      updatedTimeLabel: '最新修改时间：{date}',
      releasedTimeLabel: '最新发布时间：{date}',
      iconAlt: '图标',
      unpublished: '未发布',
      published: '已发布',
      coverAlt: '封面',
      menuPlay: '播放',
      menuEditName: '修改名称',
      menuEditAudienceScope: '公开设置',
      menuDelete: '删除',
      deletePackageTitle: '课件包删除',
      deletePackageConfirm: '你确定要删除该课件包么？',
      deleteSuccess: '删除成功',
      use: '获取',
      originalCreator: '原创人 · {name}',
      typeName: '课件包',
      tipTitle: '提示',
      acquiredPrefix: '您已经成功获取{type}，请至',
      myAcquired: '我获取的',
      acquiredSuffix: '列表下查看',
      view: '查看',
      nameDuplicated: '课件名称重复',
      alreadyAcquiredConfirm: '你已获取过该{type}，是否继续获取',
      useTitle: '获取',
      copyDescription: '复制此课程到我的{type}，获取后可以自由编辑此{type}',
      typeNameLabel: '{type}名称',
      nameRequired: '请输入名称',
      ok: '确定',
    },
    agentProcess: {
      htmlFile: 'HTML文件',
      teachingPlan: '教案',
      guidedLearningPlan: '导学案',
      verbatimScript: '授课讲稿',
      knowledgeCard: '知识卡片',
      interactiveWidget: '交互小工具',
      answerAnalysis: '答案解析',
      pblStudyPlan: 'PBL学习规划',
      evaluationForm: '评价表',
      studentActivity: '学生活动',
      roleTask: '个人角色任务',
      summaryGuidance: '总结指导',
      testPaper: '试卷',
      downloadWord: '下载为 word',
      saveToMaterial: '储存到智能素材库',
      saveMaterialSuccess: '已成功储存到智能素材库',
      fileAlreadyStored: '文件已存储',
      generating: '文件生成中，请稍后重试',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      copyTooltip: '复制内容',
      regenerate: '重新生成',
      notFinishedRetry: '内容暂未生成完毕，请稍候刷新重试',
      tabSearch: '搜索结果',
      tabPreview: '文件预览',
      emptySearch: '暂无搜索内容',
      referenceLinks: '引用链接:',
      emptyPreview: '暂无预览内容',
      close: '关闭',
      selectSubjectFirst: '请先在数智化课件中选择学科',
      downloadHtml: '下载为 HTML',
    },
    resourceCreation: {
      hintPptPdf: '仅支持PPT、PDF，200MB以内',
      hintPpt: '仅支持PPT，200MB以内',
      uploadIconAlt: '上传图标',
      clickOrDrag: '点击 / 拖拽 ',
      localFileHere: '本地文件到这里',
      uploadSuccess: '上传成功',
      unsupportedFormat: '不支持的文件格式',
      maxSizeExceeded: '上传文件不能超过200M',
      uploadUrlMissing: '上传地址不能为空',
      uploadTokenFailed: '获取上传 token 失败',
      uploadFailed: '{name} 上传失败',
      sceneLabel: '阶段',
      stepLabel: '步骤',
      scaffoldLabel: '脚手架',
      fileRequired: '请选择文件',
      modalTitleUpdate: '更新{title}PPT课件',
      modalTitleCreate: '创建{title}PPT课件',
      modalTitleUpload: '上传{title}PPT课件',
      nameDuplicated: '名称重复',
      changeSuccess: '修改成功',
      footerUpdate: '更新PPT课件',
      footerCreate: '创建PPT课件',
      gradeLabel: '年级',
      textbookLabel: '教材',
      textbookPlaceholder: '版本/教材/单元',
      moduleLabel: '模块',
      coursewareNameLabel: '课件名称',
      coursewareNameRequired: '请输入课件名称',
      coursewareNamePlaceholder: '请输入课件名称',
      pleaseSelectField: '请选择{text}',
    },
    coursewareLayout: {
      emptyUnitTitle: '当前单元暂无您自己创建或上传的课件',
      emptyUnitSubtitle:
        '请上传/创建课件或点击任意左侧课程列表中的课程分类查看资源课件',
      emptySectionTitle: '当前课程暂无您自己创建或上传的课件',
      emptySectionSubtitle: '请上传/创建课件或从下方资源课件中获取公开课件使用',
      updatedDateLabel: '更新日期',
      creatorLabel: '制作人',
      schoolLabel: '所属学校',
      typeCourseware: '课件',
      typeCoursewarePackage: '课件包',
      useCountLabel: '引用量：{count}',
      get: '获取',
      scopeBadgeAlt: '课件公开状态',
      statusTagAlt: '状态标签',
      renameSuccess: '重命名成功',
      typeNameDuplicated: '{type}名称重复',
      inputNewNameTitle: '请输入新的{type}名称',
      cancel: '取消',
      ok: '确定',
      typeNameRequired: '请输入{type}名称',
      menuRename: '重命名',
      menuEdit: '编辑',
      menuDelete: '删除',
      menuMove: '移动至',
      menuApplyUpload: '申请上传',
      menuPlay: '播放',
      iconAlt: '图标',
      tipTitle: '提示',
      gotIt: '知道了',
      pendingReviewNotice: '待学校管理员审核通过后公开{type}',
      deleteTypeTitle: '{type}删除',
      deleteTypeConfirm: '你确定要删除该{type}么？',
      deleteFailed: '删除失败',
      deleteSuccess: '删除成功',
    },
    coursewareCreation: {
      createSuccess: '创建成功',
      updateSuccess: '更新成功',
      nameDuplicated: '课件包名称重复',
      updateTitle: '更新课件包',
      createTitle: '制作课件包',
      structureLabel: '选择结构',
      structureRequired: '请选择结构',
      structureSssd: '卅三自研教学结构',
      structureFs: '自由结构',
      packageNameLabel: '课件包名称',
      packageNameRequired: '请输入课件包名称',
      packageNamePlaceholder: '请输入课件包名称吧～',
      changeCover: '修改封面',
      coverLabel: '课程封面',
      selectFieldRequired: '请{text}',
      selectGrade: '选择年级',
      selectTextbook: '选择教材',
      imageAlt: '图片',
      searchPlaceholder: '请输入文件名称',
      officialTab: '官方素材',
    },
    profileTextbook: {
      switchHint: '后续可随时在左上角切换',
      confirm: '确认',
      gradePlaceholder: '年级',
      iconAlt: '图标',
      selectPrefix: '请选择您的',
      gradeHighlight: '教学年级',
      and: '与',
      editionHighlight: '教材版本',
    },
    agentParams: {
      agreementLabel: '我已阅读并同意：{title}',
      agreementRequired: '请阅读并勾选此承诺',
      aiGenerate: 'AI智能生成',
      duration45: '45分钟',
      duration90: '90分钟',
      durationLabel: '时长',
      durationPlaceholder: '请选择时长',
      gradeLabel: '年级',
      gradeRequired: '请选择年级!',
      gradePlaceholder: '请选择年级',
      sectionLabel: '节',
      selectField: '请选择{label}',
      selectFieldWithBang: '请选择{label}!',
      subjectLabel: '学科',
      subjectRequired: '请选择学科!',
      textbookUnitLabel: '版本/教材/单元',
      textbookLabel: '版本/教材',
      noTextbook: '无相应教材',
      noTextbookTooltip: '在选项中若没有相应教材点击此按钮',
      textbookShortLabel: '教材',
      textbookRequired: '请选择教材!',
      unitShortLabel: '章',
      unitRequired: '请选择章!',
      unitPlaceholder: '请选择章',
      uploadPlanLabel: '上传教案',
      uploadPlanRequired: '请上传教案!',
      usageAgreementTip:
        '使用该功能则默认同意：本智能体生成内容仅供教学参考，最终内容的政治准确性与合规性由授课教师本人承担责任；同时默认承诺不在非教学场景使用、传播生成内容。',
      usageText: '使用声明',
      uploadSuccess: '上传成功',
      unsupportedType: '不支持的文件类型',
      maxSizeExceeded: '上传文件不能超过{limit}M',
      uploadFailed: '{name} 上传失败',
      singleFileOnly: '只支持上传一个文件',
      dropToUpload: '点击或将文件拖拽到此处上传',
      wordLimitHint: '支持上传单个word文件 ,不超过 {limit} MB',
      uploading: '上传中…',
      delete: '删除',
    },
    resourceClassification: {
      iconAlt: '图标',
      title: '资源分类',
    },
    coursewareInfo: {
      iconAlt: '图标',
      title: '课件信息',
      introTitle: '课件介绍',
      nameLabel: '课件名称',
      introLabel: '课件介绍',
      textbookLabel: '所属教材',
      publishTitle: '当前发布',
      idLabel: '课件 ID',
      versionLabel: '版本号',
      releasedAtLabel: '发布时间',
      ownerLabel: '所属人',
      useCountLabel: '获取量',
      viewCountLabel: '播放量',
    },
    operateDropdown: {
      iconAlt: '图标',
      preview: '预览',
      play: '播放',
      use: '获取',
      editFile: '编辑文件',
      edit: '编辑',
      setting: '设置',
      detail: '详情',
      delete: '删除',
      remove: '移除',
    },
    coursewareInfoPopover: {
      infoTitle: '课件信息',
      packageTitle: '课件包信息',
      packageName: '课件包',
      updatedAtLabel: '最新修改时间：',
      releasedAtLabel: '最新发布时间：',
      schoolLabel: '所属学校：',
      idLabel: 'ID：',
    },
    loading: {
      loadingText: '努力加载中，请稍等…',
      reloadPrefix: '请稍候，若长时间没有展现PPT预览，请',
      reloadPage: '刷新页面',
    },
    emptyShare: {
      emptyAlt: '空数据',
      defaultText: '暂无资源，敬请期待其他老师的分享',
    },
    emptyState: {
      emptyAlt: '空状态',
    },
    listNavigation: {
      iconAlt: '图标',
    },
    settingVisible: {
      setSuccess: '设置成功',
      setFailed: '设置失败',
      publishTitle: '发布课件',
      settingTitle: '设置',
      publishHint: '发布当前课件版本，发布时请选择课件是否公开。',
      notSchoolToast: '你还没有加入学校，无法对学校公开',
      notOwnerToast: '不能修改别人授权给自己的课件',
      creatingDisabledHint: '创建时开放权限不能进行设置',
    },
    applyRelease: {
      scopeTitle: '设置公开范围',
      scopeSchool: '学校公开（仅所属学校范围内可见）',
      scopePlatform: '平台公开（全平台范围内可见，包含所属学校）',
    },
    teachingScaffoldIcon: {
      iconAlt: '图标',
    },
    coursewareBadge: {
      canEdit: '可编辑',
      canView: '可查看',
      createdByMe: '我制作的',
    },
    coursewareHeader: {
      tabAll: '全部',
      tabSchool: '校级公开',
      tabPlatform: '平台公开',
    },
    goToCommunityButton: {
      ariaLabel: '去资源广场找找灵感',
    },
    gradeSelect: {
      placeholder: '年级',
    },
    subjectSelect: {
      placeholder: '请选择学科',
    },
    scopeSelect: {
      school: '学校公开',
      platform: '平台公开',
      placeholder: '公开范围',
    },
    publishStatusSelect: {
      published: '已发布',
      unpublished: '未发布',
      placeholder: '发布状态',
    },
    unitSelect: {
      placeholder: '请选择单元',
    },
    unitCascader: {
      placeholder: '单元/节',
    },
    textbookSelect: {
      placeholder: '请选择教材',
    },
    textbookCascader: {
      placeholder: '版本/教材',
      placeholderWithUnit: '版本/教材/单元',
    },
    subjectCascader: {
      placeholder: '学科/年级',
    },
    teachingCaseSelect: {
      placeholder: '案例级别',
    },
    stepSelect: {
      placeholder: '步骤',
    },
    sectionSelect: {
      placeholder: '请选择节',
    },
    scaffoldSelect: {
      placeholder: '脚手架',
    },
    moduleSelect: {
      placeholder: '模块',
    },
    editionSelect: {
      placeholder: '请选择版本',
    },
    coursewareFilter: {
      searchPlaceholder: '请输入课件包名称搜索',
    },
    settingModal: {
      title: '课件包设置',
      goPublish: '去发布',
      unpublishedHint: '该课件包未发布，无法进行设置！',
    },
  },
  myStudents: {
    identityNotFoundTitle: '教师身份未开通',
    identityNotFoundDesc:
      '当前账号尚未开通学生管理，请联系学校管理员添加教师身份。',
    loadFailed: '加载失败，请刷新重试',
    panelTitle: '我的学生',
    panelSubtitle: '分组管理·个人标签',
    groupLimitTooltip: '分组数量已达上限（{limit} 个）',
    createGroup: '新建分组',
    renameGroup: '重命名分组',
    groupNamePlaceholder: '请输入分组名称（上限10个汉字）',
    groupNameOverLimit: '分组名称不能超过 {max} 个字',
    deleteGroupTitle: '确定删除此分组？',
    deleteGroupWithStudents:
      '本分组下有{count}名学生，仅删除分组，学生不会删除，可从【全部学生】中查找学生并重新分组。',
    deleteGroupNoRestore: '删除后不可恢复',
    allStudents: '全部学生',
    studentCount: '{total}名学生',
    addStudent: '添加学生',
    addStudentMember: '添加学生成员',
    searchPlaceholder: '请输入学生姓名/学号搜索',
    emptyGroup: '该分组空空如也，快来添加学生！',
    bindStudentTitle: '绑定新学生',
    bindStudentPlaceholder: '请输入学生学号搜索',
    addMembersTitle: '添加学生成员（{group}）',
    transferJoined: '已加入',
    transferJoin: '加入',
    transferRemove: '移除',
    itemUnit: '名学生',
    itemsUnit: '名学生',
    transferNotFound: '暂无学生',
    transferSearchPlaceholder: '姓名 / 学号',
    tagManageTitle: '标签管理',
    studentLabel: '学生：{name}',
    tagNamePlaceholder: '请输入标签名称',
    tagNameOverLimit: '标签名称不能超过 {max} 个字',
    tagLimitReached: '标签数量已达上限，请调整后重新添加',
    existingTags: '已有标签',
    removed: '已移除',
    remove: '移除',
    removeConfirmTitle: '移除',
    removeConfirmContent: '是否将此学生从当前分组移除？',
    tagsLabel: '个人标签：',
    groupsLabel: '所属分组：',
    add: '添加',
    noTags: '暂无标签',
    ungrouped: '未分组',
    ok: '确定',
    cancel: '取消',
    rename: '重命名',
    deleteGroup: '删除分组',
    moreActions: '更多操作',
    deleteTagAria: '删除标签',
  },
};
